import { createAppReducer, apiReducerSwitch } from 'lib/redux/reducerUtils'
import {
  API_CALL_FAILURE,
  API_CALL_REQUEST,
  API_CALL_SUCCESS,
} from 'actions/actionConstants'
import { FETCH_PASSPORT_CARD_INSURANCE_QUOTE } from 'actions/apiActionConstants'
import { getCurrentIntl } from 'i18n/util/currentIntl'

function extractError(error: any): string {
  const intl = getCurrentIntl()

  if (typeof error === 'string') {
    return error
  }
  if (!error) {
    return intl.formatMessage({
      id: 'DxkpWcYQr0HGgIi_bMEK',
      defaultMessage: 'An unknown error occurred',
      description: 'Fallback error message shown when passport card insurance quote request fails without any usable error details',
    })
  }
  const { errors, message } = error
  if (Array.isArray(errors) && errors.length > 0 && errors[0].message) {
    return errors[0].message
  }
  return message
}

export const initialPassportCardInsuranceState: App.PassportCardInsuranceState = {
  quotes: {},
  fetchingQuotes: {},
  fetchQuotesErrors: {},
}

const apiCalls = apiReducerSwitch<App.PassportCardInsuranceState>({
  [FETCH_PASSPORT_CARD_INSURANCE_QUOTE]: {
    request: (state, action) => ({
      fetchingQuotes: {
        ...state.fetchingQuotes,
        [action.key]: true,
      },
      fetchQuotesErrors: {
        ...state.fetchQuotesErrors,
        [action.key]: undefined,
      },
    }),
    success: (state, action) => ({
      fetchingQuotes: {
        ...state.fetchingQuotes,
        [action.key]: false,
      },
      quotes: {
        ...state.quotes,
        [action.key]: action.data,
      },
      fetchQuotesErrors: {
        ...state.fetchQuotesErrors,
        [action.key]: undefined,
      },
    }),
    failure: (state, action) => ({
      fetchingQuotes: {
        ...state.fetchingQuotes,
        [action.key]: false,
      },
      fetchQuotesErrors: {
        ...state.fetchQuotesErrors,
        [action.key]: extractError(action.error),
      },
    }),
  },
})

const passportCardInsuranceReducer = createAppReducer<App.PassportCardInsuranceState>(
  initialPassportCardInsuranceState,
  {
    [API_CALL_REQUEST]: (state, action) => apiCalls(state, action),
    [API_CALL_SUCCESS]: (state, action) => apiCalls(state, action),
    [API_CALL_FAILURE]: (state, action) => apiCalls(state, action),
  },
)

export default passportCardInsuranceReducer
